var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.7871,
    cy: 51.4745,
    rx: 48.7871,
    ry: 48.5255,
    fill: "#CEE9C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.4721 67.3611L66.9444 75L70.4166 67.3611L78.0555 63.8889L70.4166 60.4167L66.9444 52.7778L63.4721 60.4167L55.8333 63.8889L63.4721 67.3611Z",
    fill: "#3E7D1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7222 69.4444L37.7778 54.1667L22.5 47.2222L37.7778 40.2778L44.7222 25L51.6667 40.2778L66.9444 47.2222L51.6667 54.1667L44.7222 69.4444Z",
    fill: "#57B02A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 70H17.5",
    stroke: "#F6FCF3",
    strokeWidth: 1.7586,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 75V65",
    stroke: "#F6FCF3",
    strokeWidth: 1.54442,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51.25H87.5",
    stroke: "#57B02A",
    strokeWidth: 1.7586,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.25 55V47.5",
    stroke: "#57B02A",
    strokeWidth: 1.54442,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 6.25H31.25",
    stroke: "#3E7D1E",
    strokeWidth: 1.7586,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35 10V2.5",
    stroke: "#3E7D1E",
    strokeWidth: 1.54442,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0164 19.5481C95.0078 22.0582 95.3986 26.525 92.8885 29.5164C90.3784 32.5078 85.9116 32.8986 82.9202 30.3885C79.9288 27.8784 79.538 23.4116 82.0481 20.4202C84.5582 17.4288 89.025 17.038 92.0164 19.5481Z",
    stroke: "#3E7D1E",
    strokeWidth: 2.01507
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5363 27.5961C31.2439 29.029 31.467 31.5787 30.0342 33.2863C28.6014 34.9938 26.0516 35.2169 24.3441 33.7841C22.6365 32.3513 22.4134 29.8015 23.8462 28.094C25.2791 26.3864 27.8288 26.1633 29.5363 27.5961Z",
    stroke: "#57B02A",
    strokeWidth: 1.15024
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3151 81.9996C37.4524 83.793 37.7316 86.9845 35.9382 89.1218C34.1447 91.2591 30.9533 91.5383 28.8159 89.7449C26.6786 87.9515 26.3994 84.76 28.1928 82.6227C29.9863 80.4853 33.1777 80.2061 35.3151 81.9996Z",
    stroke: "#57B02A",
    strokeWidth: 1.43974
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.758744d7.svg";
export { ForwardRef as ReactComponent };